<template>
    <div class="bind">
        <div>请在"闪易"App中扫描该二维码</div>
    </div>
</template>

<script>
    export default {
        name: "Bind"
    }
</script>

<style scoped>
.bind{
    text-align: center;
    font-size: 3vh;
    font-weight: bolder;
    padding-top: 4vh;
}
</style>
